<div>
  <div class="container">
    <div class="row">
      <div class="col-6">
        <p>1. Selecciona un rango de fechas para generar tu reporte</p>
        <app-rangodefechas></app-rangodefechas>
      </div>
      <div class="col-6">
        <p>2. Haz click en el botón para generar el reporte</p>
        <button class="btn-warning  btn-block" (click)="generarReporte()">Generar reporte</button>
      </div>
    </div>
  </div>
    
</div>
<hr>

<div>
    <div  color="light" *ngIf="tablavisible" >
      <div style="text-align: center; color: rgb(15, 71, 145);"><h3>Lista de reportes</h3></div>
      

        <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="display compact" id="tabla"  >
          <thead>
            <tr>
              <th>Detalles</th>
              <th>Nombre</th>
              <th>Cédula</th>
              <th>Fecha</th>
              <th>Email</th>
              <th>Color</th>
              <th>Director</th>
              <th>Síntomas</th>
              <th>Ticket</th>
            </tr>
          </thead>
          <tbody>
             

            <tr *ngFor="let item of arraydeposts">
              <td><button type="button" class="btn btn-info" (click)="detallesUsuario(item.data().cedula)">Detalles</button></td>
              <td><small>{{item.data().nombre}}</small></td>
              <td><small>{{item.data().cedula}}</small></td>
              <td><small>{{item.data().fecha}}</small></td>
              <td><small>{{item.data().email}}</small></td>
              <td><small *ngIf="item.data().color == 'rojo'" style="color: rgb(160, 7, 7);"><strong>{{item.data().color}}</strong></small><small *ngIf="item.data().color == 'verde'" style="color: rgb(71, 145, 22)">{{item.data().color}}</small></td>
              <td><small>{{item.data().director.nombre}} - {{item.data().director.email}}</small></td>
              <td><small>{{item.data().sintomas}}</small></td>
              <td><small>{{item.data().ticket}}</small></td>
            </tr>
            
          </tbody>
        </table>

       </div> 
</div>
